import React, { useEffect, useState } from "react";
import { useAppSelector } from "../../../redux/hook";
import { useLazyFavoriteByUserQuery } from "../../../utils/api/favories/favorie.api";
import { AlertInfo } from "../../common/Alert";
import { BestSellerCard } from "../../HomePage/BestSellerCard";
import { ProductItemsSkeleton } from "../../user/ParcoursAchat/ParcoursAchat";

const FavorisPage = () => {
  const [page, setPage] = useState(1);
  const { user } = useAppSelector((s) => s?.user);

  const [findBySlug, { data, isError, isLoading }] =
    useLazyFavoriteByUserQuery();

  useEffect(() => {
    if (user?.slug) {
      findBySlug(user?.slug as string);
    }
  }, [user]);

  console.log("data", data);

  return (
    <div className="form-register-tabs-component">
      <div className="content-title-form-register pb-4">
        <h3 className="user-parcours-title">Mes favoris</h3>
      </div>
      <div className="content-panier-page mt-5 favoris-page-content">
        <div className="best-sellers-section-grid favoris-page-grid">
          {!!isLoading && <ProductItemsSkeleton />}
          {!isLoading &&
            (data?.length ? (
              data?.map((item) => (
                <div
                  className="best-sellers-section-grid-item"
                  key={item?.id}
                >
                  <BestSellerCard item={item?.produit} />
                </div>
              ))
            ) : (
              <div className="favoris-empty-message" style={{ gridColumn: "1 / -1" }}>
                <AlertInfo message="Aucun produit disponible dans vos favoris!" />
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default FavorisPage;
